import { ReactNode } from "react";
import { View } from "./View";

export interface ILRSectionProps {
  leftText: ReactNode;
  rightText: ReactNode;
  className?: string;
}

export const LRSection = (props: ILRSectionProps) => {
  return <View {...props} />;
};
